/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/array/ArraySequenceEqual.ts
 * @create:      2025-06-26 15:59:16.615
 * @modify:      2025-07-11 21:19:12.779
 * @version:     6.0.0
 * @times:       5
 * @lines:       60
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Determines whether two arrays are equal by comparing their elements in sequence.
 *
 * @param array - The first array to compare.
 * @param other - The second array to compare.
 * @returns `true` if both arrays have the same length and all corresponding elements are strictly equal (`===`); otherwise, `false`.
 * 
 * @since 4.0.0
 * @version 2025-06-27
 */
export function ArraySequenceEqual<T>(array: T[], other: T[]) {
    if (array === other) {
        return true;
    }

    if (array.length !== other.length) {
        return false;
    }

    for (let i = 0; i < array.length; i++) {
        if (array[i] !== other[i]) {
            return false;
        }
    }

    return true;
}
